import StepConfigDialog from "@/components/POI/StepConfigDialog/StepConfigDialog.vue";
import CategoryGroupConfig from "@/components/POI/CategoryGroupConfig/CategoryGroupConfig.vue";
import CategoryTypeEditDialog from "@/components/POI/CategoryTypeEditDialog/CategoryTypeEditDialog.vue";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "CategoryGroups",
  components: { StepConfigDialog, CategoryGroupConfig, CategoryTypeEditDialog },
  data: () => ({
    selectedCatType: {},
    typeStepItems: [],
    editedType: {},
    catTypeDialog: false,
    showTypeStepDialog: false,
    showGroupStepDialog: false
  }),
  mounted() {
    this.$store.dispatch("getCategoryGroups", true);
    this.$store.dispatch("getCategoryTypes", true);
  },
  methods: {
    toggleCatTypeDialog() {
      this.catTypeDialog = false;
    },
    editType() {
      this.editedType = this.selectedCatType;
      this.catTypeDialog = true;
    },
    async deleteCategoryType() {
      const confirm = await this.$confirm(
        "Möchten Sie diesen Kategorie-Typen wirklich löschen?"
      );
      if (confirm) {
        const headers = getTokenHeader();
        const response = await axios.delete(
          `${env.poi_api_client_url}categoryType/${this.selectedCatType._id}`,
          {
            headers
          }
        );
        if (response.status === 200) {
          this.$emit("success", "Kategorie-Typ gelöscht");
          this.$store.dispatch("getCategoryTypes", true);
          this.selectedCatType = {};
        } else this.$emit("error", "Fehler beim Löschen des Kategorie-Typen");
      }
    },
    getClasses(catTypeId) {
      if (catTypeId === this.selectedCatType._id)
        return "bg-main-peacock color-white";
      else if (
        this.selectedCategoryTypes?.filter(sCType => sCType._id === catTypeId)
          .length > 0
      )
        return "bg-main-grey color-white";
      else return "bg-white";
    },
    closeTypeStepConfig() {
      this.showTypeStepDialog = false;
    },
    closeGroupStepConfig() {
      this.showGroupStepDialog = false;
    },
    getSelectedCatGroupState(catGroupId) {
      return (
        this.selectedCategoryGroups?.filter(
          sCGroup => sCGroup._id === catGroupId
        ).length > 0
      );
    },
    async saveCategoryType(types) {
      try {
        await types.asyncForEach(async type => {
          const headers = getTokenHeader();
          await axios.put(
            `${env.poi_api_client_url}categoryType/${type._id}`,
            type,
            {
              headers
            }
          );
        });
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert!");
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError", e);
      }
    },
    async saveCategoryGroups(groups) {
      try {
        await groups.asyncForEach(async group => {
          const headers = getTokenHeader();
          await axios.put(
            `${env.poi_api_client_url}categoryGroup/${group._id}`,
            group,
            {
              headers
            }
          );
        });
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert!");
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError", e);
      }
    },
    async updateSelectedCategoryTypes(catType) {
      const currentSelectedCategoryTypes = this.categoryTypes.filter(cType =>
        cType.principals.includes(this.selectedPrincipal._id)
      );
      const removedCatType = currentSelectedCategoryTypes.filter(
        cType => !catType.includes(cType._id)
      );
      if (removedCatType.length) {
        await removedCatType.asyncForEach(async rmCatType => {
          rmCatType.principals = rmCatType.principals.filter(
            principal => principal !== this.selectedPrincipal._id
          );
          const headers = getTokenHeader();
          const response = await axios.put(
            `${env.poi_api_client_url}categoryType/${rmCatType._id}`,
            rmCatType,
            {
              headers
            }
          );
          if (response.status === 200)
            this.$emit("success", "Kategorie entfernt");
          else this.$emit("error", "Fehler beim Entfernen der Kategorie");
        });
      }
      const missingPrincipal = this.categoryTypes.filter(
        cType =>
          catType.includes(cType._id) &&
          !cType.principals.includes(this.selectedPrincipal._id)
      );
      if (missingPrincipal.length) {
        await missingPrincipal.asyncForEach(async mCatType => {
          mCatType.principals.push(this.selectedPrincipal._id);
          const headers = getTokenHeader();
          const response = await axios.put(
            `${env.poi_api_client_url}categoryType/${mCatType._id}`,
            mCatType,
            {
              headers
            }
          );
          if (response.status === 200)
            this.$emit("success", "Kategorie hinzugefügt");
          else this.$emit("error", "Fehler beim Hinzufügen der Kategorie");
        });
      }
    },
    async createGroup(categoryGroup) {
      const headers = getTokenHeader();
      const newGroup = {
        title: categoryGroup.createInputValue,
        categoryType: categoryGroup.type
      };
      if (!categoryGroup.global) newGroup.owner = this.selectedPrincipal._id;
      const response = await axios.post(
        `${env.poi_api_client_url}categoryGroup`,
        newGroup,
        {
          headers
        }
      );
      if (response.status === 201) this.$emit("success", "Gruppe erstellt");
      else this.$emit("error", "Fehler beim Erstellen der Gruppe");
      await this.$store.dispatch("getCategoryGroupsForType", {
        categoryGroup: this.selectedCatType._id,
        ignorePrincipal: true
      });
    },
    async updateGroup(categoryGroup) {
      const headers = getTokenHeader();
      const response = await axios.put(
        `${env.poi_api_client_url}categoryGroup/${categoryGroup._id}`,
        categoryGroup,
        {
          headers
        }
      );
      if (response.status === 200) this.$emit("success", "Gruppe aktualisiert");
      else this.$emit("error", "Fehler beim Aktualisieren der Gruppe");
      await this.$store.dispatch("getCategoryGroupsForType", {
        categoryGroup: this.selectedCatType._id,
        ignorePrincipal: true
      });
    },
    async removeUnselectedCatGroups(groups) {
      const headers = await getTokenHeader();
      await groups.asyncForEach(async catGroup => {
        catGroup.principals = catGroup.principals.filter(
          principal => principal !== this.selectedPrincipal._id
        );
        const res = await axios.put(
          `${env.poi_api_client_url}categoryGroup/${catGroup._id}`,
          catGroup,
          { headers }
        );
        if (res.status !== 200)
          await this.$store.dispatch(
            "createError",
            "Fehler beim entfernen von Category Gruppen"
          );
        else
          await this.$store.dispatch("createSuccess", "Erfolgreich entfernt");
      });
      await this.$store.dispatch("getCategoryGroups", true);
    },
    async addSelectedCatGroups(groups) {
      const headers = await getTokenHeader();
      await groups.asyncForEach(async catGroup => {
        catGroup.principals.push(this.selectedPrincipal._id);
        const res = await axios.put(
          `${env.poi_api_client_url}categoryGroup/${catGroup._id}`,
          catGroup,
          { headers }
        );
        if (res.status !== 200)
          await this.$store.dispatch(
            "createError",
            "Fehler beim hinzufügen von Kategoriegruppen"
          );
        else
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich hinzugefügt"
          );
      });
      await this.$store.dispatch("getCategoryGroups", true);
    },
    async catGroupAboHelper(selectedGroups) {
      const catGroupsToRemove = await this.categoryGroups.filter(
        cg =>
          !selectedGroups.includes(cg._id) &&
          cg.principals.includes(this.selectedPrincipal._id) &&
          cg.categoryType === this.selectedCatType?._id
      );
      if (catGroupsToRemove?.length)
        await this.removeUnselectedCatGroups(catGroupsToRemove);
      const catGroupsAdded = await this.categoryGroups.filter(
        cg =>
          selectedGroups.includes(cg._id) &&
          !cg.principals.includes(this.selectedPrincipal._id)
      );
      if (catGroupsAdded?.length)
        await this.addSelectedCatGroups(catGroupsAdded);
    },
    createError(error) {
      this.$emit("error", error);
    },
    createSuccess(message) {
      this.$emit("success", message);
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isPoiAdmin() {
      return this.currentUser?.scopes?.includes("role:poi_admin");
    },
    filteredTypes() {
      if (!this.isPoiAdmin) return this.categoryTypes;
      return this.categoryTypes.filter(
        type => this.selectedCategoryTypes.find(t => t._id === type._id)?._id
      );
    },
    categoryGroups() {
      return this.$store.state.categoryGroups;
    },
    categoryTypes() {
      return this.$store.state.categoryTypes;
    },
    selectedCategoryGroups: {
      get() {
        return this.categoryGroups.filter(
          cg =>
            cg.principals.includes(this.selectedPrincipal._id) &&
            cg.categoryType === this.selectedCatType._id
        );
      },
      async set(newValue) {
        await this.catGroupAboHelper(newValue);
      }
    },
    selectedCategoryTypes() {
      return this.categoryTypes.filter(ct =>
        ct.principals.includes(this.selectedPrincipal._id)
      );
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    }
  }
};
